import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { IconEdit01, IconTrash01 } from "@pentabd/icons";
import { Table } from "@pentabd/ui";

import {
  DeleteConfirmationModal,
  ErrorModal,
  SearchBox,
  SuccessModal,
} from "@components";
import { TableColumn } from "./TableColumn";
import { UpdateModal } from "./UpdateModal";

import { TablePagination } from "@helpers/tablePagination";

import { deleteETicketSettings } from "@api/e-tickets/ticket-settings";

import { TicketTypeSettingsType } from "@type/tickets/ticket-settings";

import { STATUS } from "@constants/status.hrm";
import { URLS } from "@constants/urls";

const { TICKET_TYPES } = URLS;
const { SUCCESS, FAILED } = STATUS;

export const TicketTypeListTable = ({ data }: any) => {
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState<boolean>(false);
  const [isErrorModalOpen, setIsErrorModalOpen] = useState<boolean>(false);
  const [isUpdateModalOpen, setIsUpdateModalOpen] = useState<boolean>(false);
  const [selectedId, setSelectedId] = useState<number>();
  const [selectedItem, setSelectedItem] = useState<TicketTypeSettingsType>();

  const [isConfirmationModalOpen, setIsConfirmationModalOpen] =
    useState<boolean>(false);
  const [itemId, setItemId] = useState<number>();
  const [itemName, setItemName] = useState<string>("");

  const { t } = useTranslation();
  const { control } = useForm();

  const {
    ticketTypeData,
    pagination,
    handleQuery,
    handleDeleteType,
    handleUpdateType,
  } = data || {};
  const { total } = pagination || {};

  // error and success modal
  const closeErrorModal = () => setIsErrorModalOpen(false);
  const closeUpdateModal = () => setIsUpdateModalOpen(false);

  const closeConfirmationModel = () => setIsConfirmationModalOpen(false);

  const openConfirmationModel = (itemName: string, id: string | number) => {
    setItemId(id as number);
    setItemName(itemName);
    setIsConfirmationModalOpen(true);
  };

  useEffect(() => {
    const reset = () => {
      setIsErrorModalOpen(false);
      setIsSuccessModalOpen(false);
      setIsUpdateModalOpen(false);
    };
    return reset();
  }, []);

  useEffect(() => {
    setSelectedItem(
      ticketTypeData?.find(
        (obj: TicketTypeSettingsType) => obj.id == Number(selectedId),
      ),
    );
  }, [selectedId]);

  const handleDeleteItem = (id: number) => {
    deleteETicketSettings(TICKET_TYPES, id, (response) => {
      closeErrorModal();
      if (response.status === SUCCESS) {
        setIsSuccessModalOpen(true);
        handleDeleteType(id);
      } else if (response.status === FAILED) setIsErrorModalOpen(true);
    });
  };

  const deleteAction = () => {
    closeConfirmationModel();
    handleDeleteItem(itemId as number);
  };

  return (
    <div className="pt-12 border-top">
      {/* MODAL SECTION */}
      <>
        <SuccessModal
          isModalOpen={isSuccessModalOpen}
          action={() => setIsSuccessModalOpen(false)}
          closeAble
        />
        <ErrorModal
          isModalOpen={isErrorModalOpen}
          closeModal={closeErrorModal}
        />
        <UpdateModal
          isModalOpen={isUpdateModalOpen}
          closeModal={closeUpdateModal}
          modalData={selectedItem || {}}
          handleUpdateType={handleUpdateType}
          setIsSuccessModalOpen={setIsSuccessModalOpen}
          setIsErrorModalOpen={setIsErrorModalOpen}
          setIsUpdateModalOpen={setIsUpdateModalOpen}
        />

        {isConfirmationModalOpen && (
          <DeleteConfirmationModal
            subtitle={itemName}
            isModalOpen={isConfirmationModalOpen}
            onClose={closeConfirmationModel}
            action={deleteAction}
          />
        )}
      </>
      {/* MODAL SECTION */}
      <Table
        header={{
          title: t("TICKETS.SETTINGS.TAB.TYPE.TABLE.HEADER"),
          badge: {
            label: `${total || 0}`,
            size: "sm",
            type: "primary",
          },

          buttons: [
            <SearchBox
              key="search"
              placeholder={t("TICKETS.SETTINGS.SEARCH")}
              control={control}
              handleQuery={handleQuery}
            />,
          ],
        }}
        columns={TableColumn(
          t,
          setSelectedId,
          setIsUpdateModalOpen,
          openConfirmationModel,
        )}
        // actions={[
        //   {
        //     customIcon: <IconEdit01 size={20} fill="subtitle1" />,
        //     onClick: (id) => {
        //       setIsUpdateModalOpen(true);
        //       setSelectedId(Number(id));
        //     },
        //   },
        //   {
        //     customIcon: <IconTrash01 size={20} fill="danger" />,
        //     onClick: (id) => handleDeleteItem(Number(id)),
        //   },
        // ]}
        rows={ticketTypeData}
        pagination={TablePagination(pagination, handleQuery)}
      />
    </div>
  );
};
